import {PayloadAction, PayloadActionCreator} from 'util/redux/createAction'

export interface HasMatchFunction<T> {
	match: (v: any) => v is T
}

export type AnyMatcher = ((action: PayloadAction<unknown>) => boolean) // when typing is not needed
export type Matcher<T> = HasMatchFunction<T> | ((v: any) => v is T)

export type ActionFromMatcher<M extends Matcher<any>> = M extends Matcher<
		infer T
		>
	? T
	: never

export type ActionOfAnyCreator<Matchers extends [PayloadActionCreator<any, string>, ...PayloadActionCreator<any, string>[]]> = ActionFromMatcher<Matchers[number]>

export function isAnyOf<Matcher extends [PayloadActionCreator<any, string>, ...PayloadActionCreator<any, string>[]]>(
	...matchingActions: Matcher
) {
	return (action: PayloadAction<unknown>): action is ActionOfAnyCreator<Matcher> => {
		return matchingActions.some((matcher) => matcher.match(action))
	}
}
